import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { CookiesConsentService } from '../../services/cookiesConsent.service';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-consent-banner',
  imports: [MatButton, TranslateModule],
  templateUrl: './cookie-consent-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cookie-consent-banner.component.scss',
})
export class CookieConsentBannerComponent {
  private cookieConsentService = inject(CookiesConsentService);
  protected translateService = inject(TranslateService);

  public checkCookiesConsent = computed(() => {
    return this.cookieConsentService.cookiesConsented();
  });

  public consentCookie() {
    this.cookieConsentService.setCookiesConsent();
  }
}
